import {useNavigate, useParams} from "react-router-dom";
import {TextUtil} from "base/utilities";
import {DepositoService} from "abastecemento/service";

import {ConexionEntitySummaryPanel} from "conexion/container";
import {conexionElementTypesConstants} from "conexion/model";
import {SectionField} from "base/component/presentational";
import {useConcelloAuth} from "concello/auth";

const ViewDepositoPanel = ({allowConnectionManagement = false}) => {
    const {idDeposito} = useParams();
    const navigate = useNavigate();
    const {checkAllowed} = useConcelloAuth();

    const handleClickDetail = deposito => {
        navigate(`/concellos/${deposito.concello}/depositos/${deposito.id}/summary`);
    };

    const getSectionData = deposito => {
        return (
            <>
                {deposito.sistema && (
                    <SectionField
                        label="Sistema PMAA:"
                        value={deposito.sistema_label}
                        linkPath={`/concellos/${deposito.concello}/sistemas/${deposito.sistema}/summary`}
                    />
                )}
                <SectionField label="Código:" value={deposito.codigo} />
                <SectionField
                    label="Abastecemento autónomo:"
                    value={TextUtil.formatBoolean(deposito.abastecemento_autonomo)}
                />
                <SectionField label="Titular:" value={deposito.titular_label} />
                <SectionField label="Xestión:" value={deposito.xestion_label} />
                <SectionField label="Estado:" value={deposito.estado_label} />
                <SectionField label="Posición:" value={deposito.posicion_label} />
                <SectionField label="Material:" value={deposito.material_label} />
                <SectionField label="Planta:" value={deposito.planta_label} />
            </>
        );
    };

    return (
        <ConexionEntitySummaryPanel
            service={DepositoService}
            id={idDeposito}
            title="Resumo de depósito"
            getSectionTitle={entity => `Depósito: ${entity?.codigo || entity?.id}`}
            getSectionData={getSectionData}
            onClickDetailButton={handleClickDetail}
            showClickDetailButton={entity => checkAllowed(entity.concello)}
            allowConnectionsAsOrigen={allowConnectionManagement}
            allowConnectionsAsDestino={allowConnectionManagement}
            conexionElementType={conexionElementTypesConstants.DEPOSITO}
        />
    );
};

export default ViewDepositoPanel;
